import './Project.css'

const Project = ({onClick, image, title, skill, other, date, description, tools, available}) => {
    return (
        <div className={available ? 'project-container' : 'project-container not-available-project'}>
            <img 
                className={available ? 'project-image' : 'project-image not-available-image'} src={image} alt='Struggling to see the project image? Thats ur loss!'
            ></img>
            <div className='project-text-content'>
                <div className='project-title-skill-date-container'>
                    <div className='project-title-date-container'>
                        <span className='project-title'>{title}</span>
                        <span className='project-date'>{date}</span>
                    </div>
                    <span className='project-skill'>{skill === 'Other' ? other : skill}</span>
                </div>
                <span className='project-description'>{description}</span>
                <div className='tools-container'>
                    {tools && tools.map((tool, index) => (
                        <div 
                            key={index} 
                            className='project-tool'
                            style={{ backgroundColor: tool.backgroundColor }}
                        >
                            {tool.name}
                        </div>
                    ))}
                </div>
                <span 
                    className={available ? 'project-link' : 'not-available-link'} 
                    onClick={onClick}
                >
                    {available ? 'Inspect Project' : 'Coming soon 🔥'}
                </span>
            </div>
        </div>
    )
}

export default Project
